export default function (value) {
  const regexp = /^[0-9 .,+-]*$/;

  return regexp.test(String(value).toLowerCase());
};
